var map = {
	"./brand-fill.svg": "aecb",
	"./brand.svg": "9ee1",
	"./catalog-fill.svg": "317b",
	"./catalog.svg": "4798",
	"./categories-fill.svg": "944a3",
	"./categories.svg": "77e9",
	"./countries-fill.svg": "c73d",
	"./countries.svg": "1d5e",
	"./dashboard-fill.svg": "866a",
	"./dashboard.svg": "4ca1",
	"./notification-fill.svg": "4adf",
	"./notification.svg": "d854",
	"./order-fill.svg": "30a7",
	"./order.svg": "4bad",
	"./product-fill.svg": "c969",
	"./product.svg": "de15",
	"./roles-fill.svg": "d670",
	"./roles.svg": "879b",
	"./settings-fill.svg": "f13b",
	"./settings.svg": "3ac1",
	"./store-active.svg": "5408",
	"./store-fill.svg": "b15f",
	"./store.svg": "c501",
	"./u-p-fill.svg": "1267",
	"./u-p.svg": "7496",
	"./users-fill.svg": "ffbb",
	"./users.svg": "ebae",
	"./vendor-active.svg": "b2d4",
	"./vendor.svg": "eda5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7b5";